import React from "react";
import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, className, delay = 0, y = 32, ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.8, delay, ease: EASE }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const MaskedLine = ({ children, delay = 0, className }) => (
  <span className="block overflow-hidden pb-[0.12em] -mb-[0.12em]">
    <motion.span
      className={`block ${className || ""}`}
      initial={{ y: "115%" }}
      animate={{ y: 0 }}
      transition={{ duration: 1, delay, ease: EASE }}
    >
      {children}
    </motion.span>
  </span>
);

export const ChapterTag = ({ num, label, dark = false }) => (
  <div
    className={`flex items-center gap-3 text-[11px] font-semibold uppercase tracking-[0.22em] ${
      dark ? "text-teal-200/70" : "text-stone-400"
    }`}
  >
    <span className={dark ? "text-teal-300" : "text-brand-600"}>({num})</span>
    <span>{label}</span>
    <span className={`h-px w-12 ${dark ? "bg-teal-200/30" : "bg-stone-300"}`} />
  </div>
);

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -76, duration: 1.4 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};
